// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"dddfd496","186":"6ef7d106","225":"5a88c6fa","344":"282d8846","372":"996f7b4f","681":"1dc8fd62","738":"d1ddd015","841":"e17b43cc","856":"1e916d93"}[chunkId] + ".chunk.js";
};